module.exports = __webpack_public_path__ + "img/touziguanli2.19a5860f.png";